import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { Cube } from "@/storybook/charts/multi-type-chart/components/common/Cube";
import { money } from "@/utils/numeral/money";

interface ResourceDetailsCoverageTabMetadataProgressTooltipItemProps {
  label: string;
  color?: string;
  percentage?: number;
  amount?: number;
}

export const ResourceDetailsCoverageTabMetadataProgressTooltipItem: FC<
  ResourceDetailsCoverageTabMetadataProgressTooltipItemProps
> = ({ percentage, color, label, amount }) => {
  const typographyColor = color ? "text.secondary" : undefined;

  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={1} alignItems="center">
        {color && <Cube width={3} height={14} color={color} />}

        <Typography variant="caption" color={typographyColor}>
          {label}
        </Typography>
      </Stack>

      <Typography variant="caption" fontWeight="bold" color={typographyColor}>
        {percentage}% ({money(amount)})
      </Typography>
    </Stack>
  );
};
